<template>
  <div class="m-pc-header" v-if="header.display.value">
    <img
      class="logo"
      :src="logo && logo.src.value"
      alt=""
      v-if="logo && logo.display.value"
    />
  </div>
</template>
<script>
import { $subscriber } from "fire-wind-water";
// import  service  from "../services/article";
export default {
  name: "Header",
  data() {
    return {
      logo: {
        display: {
          value: false
        },
        src: {
          vaule: ""
        }
      },
      header: {
        display: {
          value: false
        }
      }
    };
  },
  created() {
    $subscriber.subscribe("config-loaded", res => {
      this.logo = res.logo;
      if (res.top) {
        this.header = res.top;
      } else {
        this.header.display.value = true;
      }
    });
  },
  components: {}
};
</script>
